import React from "react";
import times from "lodash/times";
import PropTypes from "prop-types";
import Modal from "../../../parts/modal";
import ToolTip from "../../../parts/tooltip";
import GroupCheckbox from "../../../parts/inputs/group-checkbox";
import NumberInput from "../../../parts/inputs/number-input";

class ProgramSettingsModal extends React.Component {
  constructor(props, ctx) {
    super(props);
    this.state = {
      maxFrequency: ctx.locals.query.sessionsPerWeek || 1,
    };
    this.handleLiftFrequencyChange = this.handleLiftFrequencyChange.bind(this);
    this.liftFrequencyOptions = this.liftFrequencyOptions.bind(this);
  }

  handleLiftFrequencyChange(e) {
    this.setState({ maxFrequency: e.target.value });
  }

  liftFrequencyOptions(maxFrequency) {
    // Number of lift frequency options is the same as the number of sessions per week
    return times(parseInt(maxFrequency) + 1, (ind) => (
      <option key={ind}>{ind}</option>
    ));
  }

  render() {
    const {
      locals: { query, activeUser },
    } = this.context;
    const isPremiumCoach = false;
    const isCoach = activeUser.permissions.indexOf("coach") > -1;
    return (
      <form
        action={`/actions/cycle/${query.cycleId}/?proxyAthlete=${query.athlete}`}
        method="POST"
        data-noreset
      >
        <Modal width="600px">
          <div className="head border-divider">
            <h2 className="alt">Program Settings</h2>
          </div>

          <div className="body">
            <div
              className={`Program-Settings ${
                isPremiumCoach ? "alt-coach" : ""
              }`}
            >
              <div className="group">
                <div className="label">Program Name</div>
                <input
                  name="name"
                  className="text-input"
                  placeholder="Enter a name for your program"
                />
              </div>

              <div className="group">
                <div className="label">Goals</div>
                <input
                  name="goals"
                  className="text-input"
                  placeholder="List the goal(s) of this program"
                />
              </div>

              <div className="group">
                <div className="columns">
                  <div className="column alt-info" data-col="1/2">
                    <div className="label">Number of weeks</div>
                    <NumberInput
                      isPremiumCoach={isPremiumCoach}
                      name="numberOfWeeks"
                      className="text-input number-input"
                    />
                    {!isPremiumCoach && (
                      <ToolTip id="number-of-weeks" body="Number of weeks">
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                    {isPremiumCoach && (
                      <ToolTip
                        id="number-of-weeks"
                        body="Premium programs are required to be 4 weeks."
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                  </div>

                  <div className="column alt-info" data-col="1/2">
                    <div className="label">Sessions per week</div>
                    <select
                      name="sessionsPerWeek"
                      className="select-input"
                      defaultValue={this.state.sessionsPerWeek || null}
                      onChange={(e) => this.handleLiftFrequencyChange(e)}
                    >
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={5}>5</option>
                      <option value={6}>6</option>
                      <option value={7}>7</option>
                    </select>

                    {!isPremiumCoach && (
                      <ToolTip
                        id="sessions-per-week"
                        body="Premium programs must have the same number of workouts each week. This number can be updated on the next page."
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                    {isPremiumCoach && (
                      <ToolTip
                        id="sessions-per-week"
                        body="Premium programs must have the same number of workouts each week. This number can be updated on the next page."
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    )}
                  </div>
                </div>
              </div>

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="label">Difficulty</div>
                  <ul className="Radio-Group Difficulty-Group" data-cols="1/3">
                    <li>
                      <label className="radio-input">
                        <input name="difficulty" type="radio" value="Novice" />
                        <span className="radio" />
                        <span className="text">Novice</span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Intermediate"
                        />
                        <span className="radio" />
                        <span className="text">Intermediate</span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Advanced"
                        />
                        <span className="radio" />
                        <span className="text">Advanced</span>
                      </label>
                    </li>
                  </ul>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <GroupCheckbox
                  name="liftPriority"
                  title="Lift Priority"
                  checkboxes={[
                    { html: "Squat", value: "Squat" },
                    { html: "Bench", value: "Bench" },
                    { html: "Deadlift", value: "Deadlift" },
                  ]}
                  inputGroupClassName="Check-Group"
                />
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">Squat Frequency</div>
                      <select name="squatFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">Bench Frequency</div>
                      <select name="benchFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">Deadlift Frequency</div>
                      <select name="deadliftFrequency" className="select-input">
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">Volume</div>
                      <select name="volume" className="select-input">
                        <option value="">Choose Volume</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">Intensity</div>
                      <select name="intensity" className="select-input">
                        <option value="">Choose Intensity</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column alt-info" data-col="1/1">
                      <div className="label">Weeks out from competition</div>
                      <select
                        name="weeksToCompetition"
                        className="select-input"
                      >
                        <option value="">Choose Weeks</option>
                        <option value="four">4-Weeks</option>
                        <option value="eight">8-Weeks</option>
                        <option value="twelve">12-Weeks</option>
                        <option value="more">More than 12-Weeks</option>
                      </select>
                      <ToolTip
                        id="weeks-out-from-competition"
                        body="Weeks out from competition"
                      >
                        <div className="info">
                          <img src="/img/icons/info.svg" />
                        </div>
                      </ToolTip>
                    </div>
                  </div>
                </div>
              )}

              {(isCoach || isPremiumCoach) && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">Equipped Lifting</div>
                      <ul className="Radio-Group" data-cols="1/2">
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="true"
                            />
                            <span className="radio" />
                            <span className="text">Yes</span>
                          </label>
                        </li>
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="false"
                              defaultChecked
                            />
                            <span className="radio" />
                            <span className="text">No</span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">Equipment Required</div>
                      <select name="equipmentRequired" className="select-input">
                        <option value="">Choose equipment</option>
                        <option value="Barbell Only">Barbell Only</option>
                        <option value="Barbell / Dumbbells">
                          Barbell / Dumbbells
                        </option>
                        <option value="Barbell / Dumbbells / Cables">
                          Barbell / Dumbbells / Cables
                        </option>
                        <option value="Full Gym Capability">
                          Full Gym Capability
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="group">
                <div className="label">
                  {isPremiumCoach ? "Description" : "Notes"}
                </div>
                <textarea
                  name="description"
                  className="textarea-input"
                  placeholder={`Enter ${
                    isPremiumCoach ? "a description" : "some notes"
                  } for this program`}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/2">
                <a className="button alt" href="/actions/refresh?modal=">
                  Cancel
                </a>
              </div>

              <div
                className="column mobile-hidden"
                data-col="1/2"
                style={{ textAlign: "right" }}
              >
                <button type="submit" className="button-input">
                  Next
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

ProgramSettingsModal.contextTypes = {
  locals: PropTypes.object,
  req: PropTypes.object,
  res: PropTypes.object,
};

export default ProgramSettingsModal;
